import React, {useState} from 'react';
import './scss/process-view.scss';
import Layout from './layout';
import ProcessAdd from './process-add';
import ProcessView from './process-view';
import StatusView from './status-view';
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function Process(): React.ReactElement {
    const urlParams = new URLSearchParams(window.location.search);
    const addNew = String(urlParams.get('action'));
    let view = <div/>;
    const [statusMessage, setStatusMessage] = useState({message: '', type: StatusMessageTypeEnum.none});
    const onStatusMessage = (message: string, type: StatusMessageTypeEnum) => {
        setStatusMessage({message, type});
    };

    if (addNew === 'add') {
        view = (
            <div>
                <div className="banner"/>
                <ProcessAdd setStatusMessage={onStatusMessage}/>
            </div>
        );
    } else {
        view = (
            <ProcessView setStatusMessage={onStatusMessage}/>
        );
    }
    return (
        <Layout className="page process">
            <StatusView status={statusMessage}/>
            {view}
            <div/>
        </Layout>
    );
}

export default Process;
